import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/bwQjjTaBFPGmsVMM5LvtNo/_DSC8285.webp';
const specs = [{
  label: 'Overall Length',
  value: '6.36m'
}, {
  label: 'Berths',
  value: '2'
}, {
  label: 'Fresh Water',
  value: '100L'
}, {
  label: 'Solar',
  value: '400W'
}];
export function FeaturedModelSection() {
  return <section className="py-20 md:py-32 bg-robeta-mist/15 overflow-hidden" data-id="element-79">
      <div className="container mx-auto px-6 md:px-12" data-id="element-80">
        {/* Centered Label */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-81">
          <span className="text-robeta-copper text-xs font-bold uppercase tracking-wide-editorial" data-id="element-82">
            Featured Model
          </span>
        </motion.div>

        {/* Split Layout */}
        <div className="flex flex-col lg:flex-row" data-id="element-83">
          {/* Image Side - 60% */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-[60%] relative aspect-[4/3] lg:aspect-auto lg:min-h-[650px] bg-robeta-mist/30" data-id="element-84">
            <div className="w-full h-full relative overflow-hidden" data-id="element-85">
              <img src={IMAGE_URL} alt="Mythos 4 Two Exterior" className="w-full h-full object-cover" data-id="element-86" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent" data-id="element-87" />

              {/* Ghost Watermark Text */}
              <div className="absolute bottom-16 left-8 right-8 pointer-events-none select-none" data-id="element-88">
                <span className="text-5xl md:text-7xl lg:text-8xl font-bold uppercase tracking-editorial text-white/20 leading-none whitespace-nowrap" data-id="element-89">
                  Mythos 4 Two
                </span>
              </div>

              {/* Exterior View Caption */}
              <div className="absolute bottom-6 left-8" data-id="element-90">
                <span className="text-[10px] uppercase tracking-widest text-white/50 font-medium" data-id="element-91">
                  Exterior View
                </span>
              </div>
            </div>
          </motion.div>

          {/* Content Side - 40% */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.15
        }} className="w-full lg:w-[40%] bg-white px-8 py-12 lg:px-12 lg:py-16 flex flex-col justify-center" data-id="element-92">
            <h2 className="text-3xl md:text-4xl font-bold text-robeta-black uppercase tracking-editorial leading-tight mb-6" data-id="element-93">
              Mythos 4 Two
            </h2>

            {/* Copper Rule */}
            <div className="w-12 h-px bg-robeta-copper mb-8" data-id="element-94" />

            <p className="text-robeta-black/60 font-light leading-relaxed mb-10" data-id="element-95">
              The Mythos 4 Two redefines the Class B experience with a layout
              specifically engineered for couples who refuse to compromise on
              comfort or adventure.
            </p>

            {/* Specs Table */}
            <div className="border-t border-robeta-black/10 mb-10" data-id="element-96">
              {specs.map((spec, index) => <div key={index} className="flex justify-between items-center py-4 border-b border-robeta-black/10" data-id="element-97">
                  <span className="text-xs font-medium uppercase tracking-widest text-robeta-black/50" data-id="element-98">
                    {spec.label}
                  </span>
                  <span className="text-sm font-bold text-robeta-black" data-id="element-99">
                    {spec.value}
                  </span>
                </div>)}
            </div>

            {/* CTA */}
            <Link to="/models/mythos4two" className="inline-flex items-center text-robeta-black font-bold uppercase tracking-widest hover:text-robeta-copper transition-colors group text-sm" data-id="element-100">
              View Specifications
              <ArrowRight className="ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-101" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>;
}